/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Обший вид формы заказа обратного звонка
   */
  app.CallMeFormView = app.FormView.extend({
    el: '',
    formName: '',
    modelName: 'CallMe',
    initiatorSelector: '',
    popupContent: 'Ваша заявка отправлена',
    events: {
      'click .button': 'save',
      'click .radio_phone': 'toggleAnotherPhoneBlock',
    },
    additionalOptions: _.union([
      'initiatorSelector',
      'popupContent',
    ], app.FormView.prototype.additionalOptions),

    beforeRun: function () {
      var countryFlagModel = app.countryFlag.clone();
      countryFlagModel.unset('id');
      var phoneMask = new app.PhoneInputmaskView({
        el: this.$('.input_phone'),
        model: countryFlagModel,
      });

      phoneMask.render();
      new app.ChoiceCountryView({'el': this.$('.choice-country'), model: countryFlagModel});
    },

    /**
     * Закрытие формы
     */
    close: function () {
      this.$('.js-popup-close').click();
    },

    /**
     * Сохранение модели.
     */
    save: function () {
      var that = this,
        model = this.modelName,
        attributes = [];

      this.model = new app[model](null, {
        requestParameters: {
          // определяем параметр запроса для проверки согласия на обработку данных если задана соответствующая опция
          features: this.checkAgreement ? 'accept_agreement' : null,
        },
      });
      this.$fields.each(function () {
        if (this.name === 'phone') {
          if ($(this).prop('checked')) {
            if ($(this).hasClass('another_phone')) {
              attributes[this.name] = that.$('#another_phone_block input').val();
            } else {
              attributes[this.name] = $(this).val();
            }
          }
        } else if ($(this).attr('type') === 'checkbox') {
          attributes[this.name] = $(this).prop('checked');
        } else {
          attributes[this.name] = $(this).val();
        }
      });

      if (!attributes.phone) {
        attributes.phone = this.$('#another_phone_block input').val();
      }

      this.model.on('sync', this.success, this);
      this.model.on('error', this.error, this);
      this.model.save(attributes);
    },

    /**
     * Успешное сохранение модели
     */
    success: function () {
      this.clearErrors();
      this.close();
      this.successAfter();
      this.trigger('success');
    },

    /**
     * Ошибка валидации
     */
    error: function () {
      app.FormView.prototype.error.apply(this, arguments);
      this.trigger('error');
    },

    /**
     * Показывает или скрывает блок другого телефона
     */
    toggleAnotherPhoneBlock: function (e) {
      if ($(e.target).hasClass('another_phone')) {
        $('#another_phone_block').show();
      } else {
        $('#another_phone_block').hide();
      }
    },

    /**
     * При успешной отправке заявки на звонок, создаем окно с сообщением об этом.
     */
    successAfter: function () {
      new app.DynamicPopupView({
        className: 'callme-send-success',
        initiator: this.$(this.initiatorSelector).length ? this.$(this.initiatorSelector) : $(this.initiatorSelector),
        content: this.popupContent
      });
    },
  });
})(jQuery);

}.call(window));